import React from "react";
import { Typography } from "@mui/material";
import PdfViewer from "../Pdf/PdfViewer";

export default function MediaViewer({ fileMimeType = "", url = "" }) {
    let placeholderStyle = "medial-preview-unavailable";
    let content;

    switch (fileMimeType) {
        case "application/pdf":
            placeholderStyle = "medial-preview-unavailable";
            content = <PdfViewer src={url} />;
            break;

        default:
            content = 'Preview unavailable'
            break;
    }

    return (
        <div className={placeholderStyle}>
            <Typography component="span" variant="body2" color="textPrimary">
                {content}
            </Typography>
        </div>
    );
}
